/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureSummary } from './CaptureSummary';
import {
    CaptureSummaryFromJSON,
    CaptureSummaryFromJSONTyped,
    CaptureSummaryToJSON,
    CaptureSummaryToJSONTyped,
} from './CaptureSummary';

/**
 * 
 * @export
 * @interface LinkCapturesResponse
 */
export interface LinkCapturesResponse {
    /**
     * 
     */
    capture: CaptureSummary;
}

/**
 * Check if a given object implements the LinkCapturesResponse interface.
 */
export function instanceOfLinkCapturesResponse(value: object): value is LinkCapturesResponse {
    if (!('capture' in value) || value['capture'] === undefined) return false;
    return true;
}

export function LinkCapturesResponseFromJSON(json: any): LinkCapturesResponse {
    return LinkCapturesResponseFromJSONTyped(json, false);
}

export function LinkCapturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkCapturesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'capture': CaptureSummaryFromJSON(json['capture']),
    };
}

export function LinkCapturesResponseToJSON(json: any): LinkCapturesResponse {
    return LinkCapturesResponseToJSONTyped(json, false);
}

export function LinkCapturesResponseToJSONTyped(value?: LinkCapturesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture': CaptureSummaryToJSON(value['capture']),
    };
}

